import {ConnectionTypes} from '../../../../constants/utils/connectionTypes';
import * as R from 'ramda';

export function getProgress(serviceData, connectionType){
    if (connectionType === ConnectionTypes.bank){
        let bankData = serviceData["Bank"];
        if (!R.isNil(bankData) && bankData.length > 0){
            return 100;
        }
    }
    else{
        if (Object.keys(serviceData).indexOf(connectionType) > -1 && serviceData[connectionType].length > 0){
            return 100;
        }
    }
    return 0;
}